@if (showMenu) {
  <nav class="side-nav" [ngClass]="{ 'active': showMenu }">
    <div class="nav-fix">
      @if (menuData$ | async; as menuData) {
        <div class="nav-header">
          <div class="nav-content">
            <a [routerLink]="'/'">
              <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/logo/new-logo-m.png'"
                   class="logo" alt="logo" width="100" height="100">
            </a>
            <p class="desc">{{ headerMenuItem.description }}</p>
          </div>
          <div class="close-icon" (click)="close()" tapEffect>
            <svg xmlns="http://www.w3.org/2000/svg" height="25" viewBox="0 -960 960 960" width="25">
              <path
                d="m249-207-42-42 231-231-231-231 42-42 231 231 231-231 42 42-231 231 231 231-42 42-231-231-231 231Z"/>
            </svg>
          </div>

        </div>
        <div class="menu-list">
          <ng-container *ngrxLet="(userInfo$ | ngrxPush) as userInfo">
            <ul>
              @for (appPage of menuData?.appPages; track appPage) {
                @if ((appPage.auth && userInfo) || !appPage.auth) {
                  <li (click)="openPage(appPage)">
                    <!--<div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 -960 960 960"
                        class="cozy-icon">
                        <path
                          d="M120-540v-300h300v300H120Zm60-60h180v-180H180v180Zm-60 480v-300h300v300H120Zm60-60h180v-180H180v180Zm360-360v-300h300v300H540Zm60-60h180v-180H600v180Zm-60 480v-300h300v300H540Zm60-60h180v-180H600v180ZM360-600Zm0 240Zm240-240Zm0 240Z"/>
                        </svg>
                    </div>-->
                    <div class="title">
                      {{ appPage.title }}
                    </div>
                  </li>
                }
              }
              @if (userInfo) {
                <!--<li (click)="logout()">
                  <div class="title">
                    Logout
                  </div>
                </li>-->
              } @else {
                <li (click)="register()">
                  <!--<div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 -960 960 960"
                         class="cozy-icon">
                      <path
                        d="M120-540v-300h300v300H120Zm60-60h180v-180H180v180Zm-60 480v-300h300v300H120Zm60-60h180v-180H180v180Zm360-360v-300h300v300H540Zm60-60h180v-180H600v180Zm-60 480v-300h300v300H540Zm60-60h180v-180H600v180ZM360-600Zm0 240Zm240-240Zm0 240Z"/>
                    </svg>
                  </div>-->
                  <div class="title">
                    Register
                  </div>
                </li>
                <li (click)="login()">
                  <!--<div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 -960 960 960"
                         class="cozy-icon">
                      <path
                        d="M120-540v-300h300v300H120Zm60-60h180v-180H180v180Zm-60 480v-300h300v300H120Zm60-60h180v-180H180v180Zm360-360v-300h300v300H540Zm60-60h180v-180H600v180Zm-60 480v-300h300v300H540Zm60-60h180v-180H600v180ZM360-600Zm0 240Zm240-240Zm0 240Z"/>
                    </svg>
                  </div>-->
                  <div class="title">
                    Login
                  </div>
                </li>
              }
            </ul>
          </ng-container>
        </div>
      }
    </div>
  </nav>
}
